import PropTypes from 'prop-types';
import React, { Component } from 'react';

class MapImage extends Component {
  render() {
    return (
      <div id="regionMapArea" className="mapSelectionV2">
        <div id="map-v2">
          <img id="regionMap"
            src={`${this.props.imagePath}/map.png`}
            useMap="#region-map"
            ref="regionMap"
            className="map"
            title={this.props.text}
            alt={this.props.text}
          />
          <img id="regionMapText"
            src={`${this.props.imagePath}/map-text.png`}
            useMap="#region-map"
            title={this.props.text}
            alt={this.props.text}
          />
        </div>
      </div>
    );
  }
}

MapImage.propTypes = {
  imagePath: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default MapImage;



// WEBPACK FOOTER //
// ./src/components/search/maps/map-image.js